const actions = {
	GET_HIGHLIGHT_CORRECT_SUMMARY: 'GET_HIGHLIGHT_CORRECT_SUMMARY',
	GET_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS: 'GET_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS',

	CREATE_NEW_QUESTION_HIGHLIGHT_CORRECT_SUMMARY: 'CREATE_NEW_QUESTION_HIGHLIGHT_CORRECT_SUMMARY',
	CREATE_NEW_QUESTION_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS: 'CREATE_NEW_QUESTION_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS',

	DELETE_HIGHLIGHT_CORRECT_SUMMARY: 'DELETE_HIGHLIGHT_CORRECT_SUMMARY',
	DELETE_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS: 'DELETE_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS',

	GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL: 'GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL',
	GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL_SUCCESS: 'GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL_SUCCESS',

	UPDATE_HIGHLIGHT_CORRECT_SUMMARY_DETAIL: 'UPDATE_HIGHLIGHT_CORRECT_SUMMARY_DETAIL',
	UPDATE_HIGHLIGHT_CORRECT_SUMMARY_DETAIL_SUCCESS: 'UPDATE_HIGHLIGHT_CORRECT_SUMMARY_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getHighlightCorrectSummary: (model) => ({
		type: actions.GET_HIGHLIGHT_CORRECT_SUMMARY,
		payload: { model },
	}),

	createQuesHighlightCorrectSummary: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_HIGHLIGHT_CORRECT_SUMMARY,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getHighlightCorrectSummaryDetail: (id) => ({
		type: actions.GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL,
		payload: { id },
	}),

	updateHighlightCorrectSummaryDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_HIGHLIGHT_CORRECT_SUMMARY_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteHighlightCorrectSummary: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_HIGHLIGHT_CORRECT_SUMMARY,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
